import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import OverView from "../views/OverView.vue";
import Site from "../views/Site.vue";

Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = [{
	path: "/",
	name: "Home",
	component: Home,
	redirect: "OverView",
	children: [{
			path: "/overview",
			name: "OverView",
			component: OverView
		}, {
			path: "/site/:id",
			name: "Site",
			component: Site
		},
	]
}];

const router = new VueRouter({
	routes,
});

export default router;